<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      inactivityTimer: null,
      inactivityTime: 20 * 60 * 1000,
    };
  },
  methods: {
    throttle(func, delay) {
      let lastTime = 0;
      return function() {
        const now = new Date().getTime();
        if (now - lastTime >= delay) {
          lastTime = now;
          func.apply(this, arguments);
        }
      };
    },
    resetTimer() {
      if (this.$route.path.startsWith('/auth')) return; // Skip if on auth pages
      localStorage.setItem('lastActivity', Date.now()); // Store activity timestamp
      clearTimeout(this.inactivityTimer); // Clear the existing timer
      this.startTimer(); // Restart the timer
    },
    startTimer() {
      if (this.$route.path.startsWith('/auth')) return; // Skip if on auth pages

      this.inactivityTimer = setTimeout(() => {
        this.checkInactivity(); // Check inactivity after the timeout
      }, this.inactivityTime);
    },
    checkInactivity() {
      const lastActivity = localStorage.getItem('lastActivity');
      if (!lastActivity) return; // If no last activity, exit

      const timeElapsed = Date.now() - parseInt(lastActivity);
      if (timeElapsed > this.inactivityTime) {
        this.logoutUser(); // If inactive for too long, log out
      } else {
        this.resetTimer(); // Reset timer if still active
      }
    },
    logoutUser() {
      localStorage.clear();
      this.removeCookie('PHPSESSID')
      this.$router.push({name: 'login'})
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkInactivity(); // Check inactivity when tab is brought to focus
      }
    },
  },
  mounted() {
    if (!this.$route.path.startsWith('/auth')) {
      this.startTimer(); // Start the inactivity timer if not on auth pages
      window.addEventListener('mousemove', this.throttle(this.resetTimer, 1000)); // Throttle mouse movement event
      window.addEventListener('keydown', this.throttle(this.resetTimer, 1000)); // Throttle keydown event
      window.addEventListener('visibilitychange', this.handleVisibilityChange); // Listen for tab visibility change
    }
  },
  beforeDestroy() {
    clearTimeout(this.inactivityTimer); // Clear inactivity timer before the component is destroyed
    window.removeEventListener('mousemove', this.resetTimer); // Remove event listeners
    window.removeEventListener('keydown', this.resetTimer);
    window.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
</script>

